
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonApp, IonSplitPane, IonMenu, IonContent, IonList, IonMenuToggle, IonItem, IonIcon, IonLabel, IonRouterOutlet, IonRouterLink, IonHeader, IonFooter, IonButton } from '@ionic/angular/standalone';
import { Router } from '@angular/router';
import * as allIcons from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { NavController, AlertController } from '@ionic/angular';
import { LoginService } from './shared/services/login-service';
import { PermissionService } from './shared/services/permission.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [
    RouterLink, RouterLinkActive,
    IonApp, IonSplitPane, IonMenu, IonContent, IonList,
    IonMenuToggle, IonItem, IonIcon, IonLabel, IonRouterLink, IonRouterOutlet,
    IonHeader, IonFooter, IonButton,
    CommonModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent {
  isLogin: boolean = false;
  userRole: string = '';
  activePropertyName: string = '';
  propertyCount: number = 0;
  showLogoutModal: boolean = false;

  get showExitButton(): boolean {
    if (this.userRole === 'superadmin') return true;
    return this.propertyCount > 1;
  }

  get showMenu(): boolean {
    return this.isLogin && !!this.activePropertyName && this.router.url.includes('/dashboard');
  }

  constructor(
    private navCtrl: NavController,
    private loginService: LoginService,
    private alertCtrl: AlertController,
    private router: Router,
    public perm: PermissionService
  ) {
    this.loginService.isLoggedIn$.subscribe(val => {
      this.isLogin = val;
    });
    addIcons(allIcons);
    this.checkLogin();
    window.addEventListener('storage', () => this.checkLogin());
  }

  checkLogin() {
    const userData = JSON.parse(localStorage.getItem('UserProfileData') || '{}');
    const login = localStorage.getItem('isLoggedIn') === 'true' && !!userData?.result;
    this.isLogin = login;
    if (login) {
      this.userRole = userData?.result?.role || '';
      this.activePropertyName = localStorage.getItem('activePropertyName') || '';
      this.propertyCount = (userData?.result?.propertyIds || []).length;
    }
  }

  exitProperty() {
    localStorage.removeItem('activePropertyId');
    localStorage.removeItem('activePropertyName');
    this.activePropertyName = '';
    this.navCtrl.navigateRoot('/property-select');
  }

  Logout() {
    localStorage.removeItem('UserProfileData');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('activePropertyId');
    localStorage.removeItem('activePropertyName');
    this.loginService.logout();
    this.isLogin = false;
    this.navCtrl.navigateRoot('/login');
  }

  isActive(urlPrefixes: string[]) {
    const currentUrl = this.router.url;
    if (currentUrl.includes('complaint-detail')) {
      const isFromReport = currentUrl.includes('from=report');
      if (urlPrefixes.includes('/dashboard/complaint-report')) return isFromReport;
      if (urlPrefixes.includes('/dashboard/complaint-list')) return !isFromReport;
    }
    return urlPrefixes.some(prefix => currentUrl.includes(prefix));
  }

  confirmLogout() {
    this.showLogoutModal = true;
  }

  cancelLogout() {
    this.showLogoutModal = false;
  }

  confirmLogoutAction() {
    this.showLogoutModal = false;
    this.Logout();
  }
}
